import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { AcceptanceStatus, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';
import { isEmpty } from 'lodash';
import { ButtonVariant } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/KycActionButton.types';

interface Props {
	currentInvestor: GetKYCInvestorInstanceRes | undefined;
	currentStep: Step | null;
	variant: ButtonVariant;
}

export const isDeclarationDisabled = ({ currentInvestor, currentStep, variant }: Props) => {
	const isDeclarationsStep = currentStep?.type === 'DECLARATIONS';

	if (!isDeclarationsStep) {
		return false;
	}

	const hasNoDeclarations = isEmpty(currentInvestor?.declarations);

	if (variant === 'approve') {
		const hasNoDeclarationsProvided = currentInvestor?.declarationsProvided === false;
		const isApprovalButtonDisabled = hasNoDeclarations || hasNoDeclarationsProvided;
		return isApprovalButtonDisabled;
	}

	if (variant === 'decline') {
		const isRejected =
			currentStep?.approvalStatus === AcceptanceStatus.REJECTED ||
			currentStep?.approvalStatus === AcceptanceStatus.REREQUESTED;
		const hasNoDeclarationsAndIsRejected = hasNoDeclarations || isRejected;
		return hasNoDeclarationsAndIsRejected;
	}
};
